export const PARTIES = [
  '1PD',
  '2PD',
  '3PD'];


// WEBPACK FOOTER //
// ./src/app/services/constants/party-list.ts